export const contactContent = {
  title: "İletişim",
  subtitle:
    "Ürünlerimiz hakkında daha fazla bilgi almak, özel siparişler ya da iş birliği talepleriniz için bizimle dilediğiniz zaman iletişime geçebilirsiniz. Famento ile ilgili her türlü sorunuzu cevaplamaya hazırız.",
  hero: "/images/contact-hero.jpg",
};

export const famentoEmail = "famentodesign@gmail.com";
export const famentoInstagramAdd = "https://www.instagram.com/famentodesign/";
export const famentoInstagramName = "@famentodesign";
export const famentoShopierAdd = "https://shopier.com/famento_design";
export const famentoShopierName = "famento_design";

// FAQ Bölümü
export const faqData = {
  title: "Sık Sorulan Sorular",
  questions: [
    {
      question: "Ürünleriniz el yapımı mı?",
      answer:
        "Evet, tüm ürünlerimiz el yapımıdır. Her ürün benzersizdir ve küçük farklılıklar gösterebilir.",
    },
    {
      question: "Sipariş süreci nasıl işliyor?",
      answer:
        "Shopier mağazamızdan ürünü seçin, güvenli ödeme yapın. Ürünlerimiz el yapımı olduğundan hazırlık süresi biraz daha uzundur. Siparişiniz ortalama 5–7 iş günü içinde kargoya teslim edilir.",
    },
    {
      question: "Özel tasarım yapıyor musunuz?",
      answer:
        "Evet! Özel tasarım talepleriniz için Instagram veya e-posta ile iletişime geçebilirsiniz.",
    },
    {
      question: "Yanıt süreniz ne kadar?",
      answer:
        "Instagram mesajlarına 24 saat içinde, e-postalara 48 saat içinde yanıt veriyoruz.",
    },
    {
      question: "Çalışma saatleriniz nedir?",
      answer:
        "Pazartesi - Cuma: 09:00 - 18:00, Cumartesi: 10:00 - 14:00, Pazar: Kapalı",
    },
  ],
};

export const contactInfo = {
  title: "İletişim Bilgileri",
  responseTime:
    "Instagram mesajlarına 24 saat içinde, e-postalara 48 saat içinde yanıt veriyoruz.",
  workingHours: {
    weekdays: "Pazartesi - Cuma: 09:00 - 18:00",
    saturday: "Cumartesi: 10:00 - 14:00",
    sunday: "Pazar: Kapalı",
  },
  shipping:
    "Siparişleriniz ortalama 3–5 iş günü içerisinde kargoya teslim edilir. Özel tasarım veya kişisel talepler için bu süre 7–10 iş günü arasında değişebilir.",
};

export const ctaSection = {
  title: "Hemen Alışverişe Başlayın!",
  description:
    "El yapımı dekoratif ürünlerimizi keşfetmek için Shopier mağazamızı ziyaret edin. Güvenli ödeme, hızlı kargo ve müşteri memnuniyeti garantisi!",
  buttonText: "Shopier'da Alışveriş Yap",
};

// İletişim Kartları
export const contactCards = [
  {
    icon: "Instagram" as const,
    label: famentoInstagramName,
    href: famentoInstagramAdd,
    target: "_blank" as const,
  },
  {
    icon: "Email" as const,
    label: famentoEmail,
    href: `mailto:${famentoEmail}`,
    target: "_self" as const,
  },
  {
    icon: "Storefront" as const,
    label: famentoShopierName,
    href: famentoShopierAdd,
    target: "_blank" as const,
  },
];
